import { Interface } from '@ethersproject/abi'

export function decodeEventLogs(logs: any[], eventFragment: string, coder: Interface) {
  return logs
    ?.map((log) => {
      try {
        return coder.decodeEventLog(eventFragment, log.data, log.topics)
      } catch (err) {
        return
      }
    })
    .filter((log) => !!log)
}
